// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"323":"f1becd6a","337":"8bbc0c88","453":"aefcbdf9","660":"c285e9e3","702":"7fef797c","807":"1040b220","884":"06f124a9","962":"e0474abc"}[chunkId] + ".chunk.js";
};